<template>
  <div class="ip-project-detail-wrap">
    <div class="ip-project0head-wrap" :style="{backgroundImage: `url('/static/serviceBg.png')`}">
            <div class="title">{{resultList.title}}</div>
            <div class="mid-line"></div>
            <div class="description">{{resultList.content}}</div> 
    </div>
    <div class="ip-project-body-wrap" v-for="(item, index) in list" :key="index">
      <TitleCard :title="titleName(item, index)" :showMore="false">
        <div class="mb" v-html="contentList(item, index)"></div>
      </TitleCard>
    </div>
  </div>
</template>

<script>
import { checkIpProject } from '@/api/IpProject.js'


export default {
  data() {
    return {
      resultList: {},
      headImg: '',
      list:[]
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const id = Object.keys(this.$route.query)
      const { data } = await checkIpProject(id)
      const type1 = 'content'
      const type2 = 'section'
      const forbiddenMap = ['content', 'contentVos']
      const map = new Map()
      Object.keys(data).forEach(key => {
        if(forbiddenMap.includes(key)) return
        const isType1 = key.indexOf(type1) !== -1
        const isType2 = key.indexOf(type2) !== -1
        if(isType1 || isType2) {
          const v = data[key] || ''
          if(!v) return
          const idx = key.slice(-1) // 取出字符串最后的值
          const isHasMap = map.has(idx)
          if(isHasMap) {
            const target = map.get(idx) // { 1: { content1: 'xxx' } }
            target[key] = v // { 1: { content1: 'xxx', section1: 'zzzz' } }
            map.set(idx, target)
          } else {
            map.set(idx, { [key]: v })  // { 1: { content1: 'xxxx' } }
          }
        }
      })
      // [...map] => [[1, {}]], [2, {}]]
      const sectionList = [...map].map(item => item[1])   // [{ section1: 'xxx', content1: 'zzz'}, {...}]
      // console.log(sectionList,'sectionList')
      this.list = sectionList
      this.headImg = data.fileVo[0].filePath
      this.resultList = {...data}
    },
    titleName(instance, idx) {
      return instance[`section${idx + 1}`]
    },
    contentList(instance, idx){
      return instance[`content${idx + 1}`]
    }
  }
}
</script>
<style scoped>
.idv{
  width: 100%;
  height: 300px;
}
</style>
